"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _SystemIcons = require("../SystemIcons");

var _core = require("@emotion/core");

var SvgThermometer = function SvgThermometer(props) {
  return (0, _core.jsx)(_SystemIcons.SystemIcons, props, (0, _core.jsx)("path", {
    d: "M28.763 32.098A5.5 5.5 0 1120 26.258V15.5a3.5 3.5 0 017 0v10.759a5.5 5.5 0 011.763 5.84zM25 26.76V15.5a1.5 1.5 0 00-3 0v11.26a1 1 0 01-.444.831 3.5 3.5 0 103.888 0A1 1 0 0125 26.76z",
    id: "thermometer_svg__a"
  }));
};

var _default = SvgThermometer;
exports["default"] = _default;